import * as React from 'react';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Button, Tooltip, Typography } from '@mui/material';
import { ColorPalette } from '../../../../../components/config';
// import { IToolbarProps } from './toolbar-props';
// import './toolbar.scss';
export interface IUniToolbarHeaderProps {
  selectedItemsCount: number;
  numberOfResults?: number;
  title: string | JSX.Element;
  resultTypeName: string | JSX.Element;
  onClickNameChooser: (event: React.MouseEvent<HTMLButtonElement>) => void;
}
export function ToolbarTitle(props: IUniToolbarHeaderProps) {
  const { selectedItemsCount, onClickNameChooser, title, resultTypeName, numberOfResults } = props;
  let calcTitle = '';
  if (numberOfResults !== undefined) {
    calcTitle = title ? `${title} (${numberOfResults} ${resultTypeName})` : '';
  }
  if (selectedItemsCount > 0) {
    return (
      <div>
        <h3 className="toolbar-title toolbar-title--withSelectedCheckboxes" data-vanguard="dashboard-toolbar-title">
          {selectedItemsCount} valgt
        </h3>
      </div>
    );
  }
  if (onClickNameChooser && title) {
    return (
      <Tooltip style={{ cursor: 'pointer' }} key="newChart" title={title}>
        <Button
          style={{ textTransform: 'none', height: 30, color: ColorPalette.DefaultTextColor }}
          onClick={onClickNameChooser}
          endIcon={<ExpandMore />}
          aria-label="Vælg en arbejdsliste"
          data-vanguard="dashboard-toolbar-title"
        >
          <Typography noWrap className="toolbar-title">
            {calcTitle}
          </Typography>
        </Button>
      </Tooltip>
    );
  }
  return (
    <div>
      <h3 className="toolbar-title">{title}</h3>
    </div>
  );
}
